import style from "./UpgradeToPremium.module.css";
import { useTranslation } from "react-i18next";
import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";
import { usePriceInfo } from "@/features/payments/hooks/usePriceInfo";
function UpgradeToPremium() {
	const { t } = useTranslation();
	const plan = {
		name: t("auth:upgrade.name"),
		benefits: [
			{
				name: t("auth:upgrade.benefits.content"),
				check: true,
			},
			{
				name: t("auth:upgrade.benefits.features"),
				check: true,
			},
			{
				name: t("auth:upgrade.benefits.certificate"),
				check: true,
			},
			{
				name: t("auth:upgrade.benefits.ai"),
				check: true,
			},
		],
	};

	return (
		<div className={`${style.offer} ${style.preferred}`} key={plan.name}>
			<div className={style.offerHeader}>
				<h3>{plan.name}</h3>
			</div>
			<div className={style.offerBody}>
				<ul>
					{plan.benefits.map((benefit, index) => (
						<li key={index}>
							<Icon
								icon={benefit.check ? "fa-check" : "fa-times"}
							/>
							<span>{benefit.name}</span>
						</li>
					))}
				</ul>
			</div>
			<div className={style.offerFooter}>
				<Button
					to="plans"
					onClick={plan.onSelect}
					className={style.btn}
				>
					{t("auth:upgrade.action")}
					<Icon icon="fa-long-arrow-right" />
				</Button>
			</div>
		</div>
	);
}

export default UpgradeToPremium;
